export default __webpack_public_path__ + "static/media/btn_big_new.d9894a95.svg";